import { BaseProduct, ProductBuilderMachineState } from '../types';
import { getStatesForProductType } from './getStatesForProductType';

type GetCommonStatesFromProducts = (
  products: BaseProduct[],
) => ProductBuilderMachineState[];

export const getCommonStatesFromProducts: GetCommonStatesFromProducts = products => {

  const allProductTypes = Array.from(
    new Set(
      products.map(product => {
        if (window.location.pathname.includes('roller-day-night') === false) {
          return product.type;
        } else {
          if (product.type === 'Roller Blind Single Chain') {
            return 'Roller Blind Day/Night Chain';
          } else if(product.type === 'Roller Blind Premium Chain') {
            return 'Roller Blind Premium Chain'
          } else {
            return 'Roller Blind Day/Night Chainless';
          }
        }
      }),
    ),
  );

  const stateSets = allProductTypes.map(productType => {
    return getStatesForProductType(productType);
  });
  const commonStates = stateSets.reduce((accumulator, stateSet) => {
    const uniqueStates = stateSet
      .filter(state => !accumulator.includes(state))
      .filter(state => stateSets.every(set => set.includes(state)));
    return [...accumulator, ...uniqueStates];
  }, []);

  return commonStates;
};
